import {
    configureStore,
    combineReducers,
    getDefaultMiddleware
} from '@reduxjs/toolkit';

import productFinderReducer from './slices/productFinder';

const combinedReducer = combineReducers({
    productFinder: productFinderReducer
});

const rootReducer = (state, action) => {
    return combinedReducer(state, action);
};

export default configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware()],
});
